module.exports = __webpack_public_path__ + "static/media/dashboard-nav-icon.3819ff71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/light-nav-images/dashboard-nav-icon.svg
// module id = 570
// module chunks = 0